import React from 'react';
import { Card } from 'react-bootstrap';

import { renderLegends } from '../../../../support/SingleLeyendLabel';
import ComplementoSummaryActionButtons from '../components/ComplementoSummaryActionButtons';

const ComplementoEnajenaciondeAccionesResumen = ({ data = [], onEdit, onDelete }) => {

  const handleOnDelete = () => {
    onDelete('EnajenaciondeAcciones');
  }

  const handleOnEdit = () => {
    onEdit('EnajenaciondeAcciones', data);
  }

  return (
    <Card>
      <Card.Body>

        <Card.Subtitle className="text-center">
          Enajenación de Acciones, Versión { data.Version }
        </Card.Subtitle>

        { labels.map(renderLegends(data)) }

        <ComplementoSummaryActionButtons onEdit={ handleOnEdit} onDelete={ handleOnDelete } />

      </Card.Body>
    </Card>
  )
}

const labels = [
  {
    label: 'Ganancia',
    index: 'Ganancia'
  },
  {
    label: 'Pérdida',
    index: 'Perdida'
  },
  {
    label: 'Contrato de intermediación',
    index: 'ContratoIntermediacion'
  }
];

export default ComplementoEnajenaciondeAccionesResumen
